export enum PoolName {
  City = 'City',
  Intermediate = 'Intermediate',
  Chemicals1 = 'Chemicals 1',
  Chemicals2 = 'Chemicals 2',
  Chemicals3 = 'Chemicals 3',
  Chemicals4 = 'Chemicals 4',
  Flexi = 'Flexi',
  Handy = 'Handy',
  Panamax = 'Panamax',
  LR1 = 'LR1',
  LR2 = 'LR2',
  MR = 'MR',
  Aframax = 'Aframax',
  Suezmax = 'Suezmax',
  VLAC = 'VLAC',
}
export const dppPoolNames: readonly string[] = [
  PoolName.Panamax,
  PoolName.Aframax,
  PoolName.Suezmax,
]

export function isDppPool(poolName?: string) {
  return dppPoolNames.includes(poolName ?? '')
}

const poolCompanyCodes: Partial<Record<PoolName, string>> = {
  [PoolName.City]: 'CTPOOL',
  [PoolName.Intermediate]: 'BRPOOL',
  [PoolName.Chemicals2]: 'CHEMS2',
  [PoolName.Handy]: 'MHANDY',
  [PoolName.MR]: 'MRPOOL',
  [PoolName.LR1]: 'LR1POL',
  [PoolName.Aframax]: 'DPAFRA',
  [PoolName.Panamax]: 'DPPANA',
  [PoolName.Suezmax]: 'DPSUEZ',
}

export function getPoolCompanyCode(pool?: string) {
  if (!pool) return undefined
  const poolName = Object.values(PoolName).find(
    (name) => name.toLowerCase() === pool.toLowerCase(),
  )
  return poolName ? poolCompanyCodes[poolName] : undefined
}
